import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SilentRequest } from '@azure/msal-browser';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment.demo';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  image = '../../../../assets/theme/img/landingBannerPurple.png';
  bannerTitle = 'Industry X Developer Hub';
  bannerSubHeading = '';
  bannerDescription = 'Access and Contribute reusable IP to accelerate Client outcomes';
  homePageData: any;
  showDisclaimerPopup: boolean;
  DISCLAIMER_POPUP = 'disclaimer-box';
  donotshowagain: boolean;
  popupFlag: number;
  username: any;
  userRoleData: any;
  apiTimer: any;

  requesttoken: SilentRequest = {
    scopes: [environment.clientId + '/user.read'],
    account: undefined,
    // account: this.msalService.instance.getAllAccounts()[0]
  };

  constructor(private _appService: AppService,    private authService: MsalService, private router: Router, private activeRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this._appService.checkRefreshTokenValidity();
    this.requesttoken.account = this.authService.instance.getAllAccounts()[0]
            this.authService.acquireTokenSilent(this.requesttoken).subscribe(result => {
              // console.log("SilentToken response in HomeComponent...", result);
              sessionStorage.setItem('accessToken', result.accessToken);
              this._appService.jwtAuthorizationToken=result.accessToken;
              this.getHomePageData();
            })

    window.scrollTo(0, 0);
  }

  getHomePageData() {
    this._appService.getUsername().subscribe(userdata => this.username = userdata);
    this.apiTimer = setInterval(() => {
      this._appService.getHomePagedetails(this.username).subscribe((res) => {
        if (res) {
          this.homePageData = res;
          localStorage.removeItem('userRoleData');
          localStorage.setItem('userRoleData', this.homePageData.UserRoleData.Role_Id);
        }
        if (this.homePageData) {
          clearInterval(this.apiTimer);
        }
      });
    }, 2000)


    if (this._appService.isLoggedIn === true) {
      this.showDisclaimerPopup = true;
      this._appService.isLoggedIn = false;
    }

  }
  seeMoreAssetsClicked() {
    this.router.navigate(['/asset-home']);
  }
  closepopup() {
    this.showDisclaimerPopup = false;
  }

  togglecbdnotshow() {
    this.donotshowagain = (this.donotshowagain === true) ? false : true;
    if (this.donotshowagain === true) {
      this.popupFlag = 1
    }
  }
}
